import {
    FETCH_CONFIGURABLES_REQUEST,
    FETCH_CONFIGURABLES_SUCCESS,
    FETCH_CONFIGURABLES_FAILURE,
    UPDATE_CONFIGURABLE_REQUEST,
    UPDATE_CONFIGURABLE_SUCCESS,
    UPDATE_CONFIGURABLE_FAILURE,
  } from '../actions/configActions';
  
  const initialState = {
    data: [],
    loading: false,
    error: null,
  };
  
  const configReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CONFIGURABLES_REQUEST:
      case UPDATE_CONFIGURABLE_REQUEST:
        return { ...state, loading: true };
  
      case FETCH_CONFIGURABLES_SUCCESS:
        return { ...state, loading: false, data: action.payload };
  
      case UPDATE_CONFIGURABLE_SUCCESS:
        return {
          ...state,
          loading: false,
          data: state.data.map(item =>
            item.key === action.payload.key ? { ...item, value: action.payload.value } : item
          ),
        };
  
      case FETCH_CONFIGURABLES_FAILURE:
      case UPDATE_CONFIGURABLE_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default configReducer;
  